import client from './httpClient'
import { ADMIN_ENDPOINTS } from '../../constants/apiEndpoints'
import { User, Order, UserAuthType, CancelOrderRequest } from '../types'
import { FaqRequest } from '../types/faq'
import { NoticeRequest } from '../types/notice'

export default {
  getPagedUsers(pageNumber: number, pageSize: number, authType: UserAuthType | null) {
    let query = `?pageNumber=${pageNumber}&pageSize=${pageSize}`

    if (authType !== undefined && authType !== null) {
      query += `&userAuthorityType=${authType}`
    }

    return client.get(ADMIN_ENDPOINTS.PAGED_USERS + query)
  },
  postUser(user: User) {
    return client.post(ADMIN_ENDPOINTS.UPDATE_USER, user)
  },
  postOrder(order: Order) {
    return client.post(ADMIN_ENDPOINTS.UPDATE_ORDER, order)
  },
  getAdOrders(
    pageNumber: number,
    pageSize: number,
    orderStatus?: number | null,
    storeId?: string | null,
    userId?: string | null,
  ) {
    let query = ADMIN_ENDPOINTS.PAGED_AD_ORDER + '?pageNumber=' + pageNumber + '&pageSize=' + pageSize

    if (orderStatus != null) {
      query += '&orderStatus=' + orderStatus
    }

    if (storeId != null) {
      query += '&storeId=' + storeId
    }

    if (userId != null) {
      query += '&userId=' + userId
    }

    return client.get(query)
  },
  postCancelOrder(cancelRequest: CancelOrderRequest) {
    return client.post(ADMIN_ENDPOINTS.CANCEL_AD_ORDER, cancelRequest)
  },
  getPagedFaqs(pageNumber: number, pageSize: number) {
    const query = `?pageNumber=${pageNumber}&pageSize=${pageSize}`
    return client.get(ADMIN_ENDPOINTS.PAGED_FAQS + query)
  },
  deleteFaq(faqId: string) {
    return client.delete(`${ADMIN_ENDPOINTS.DELETED_FAQ}/${faqId}`)
  },

  postFaq(faqData: FaqRequest) {
    const payload = { ...faqData }
    if (!payload.faqId) {
      payload.faqId = '00000000-0000-0000-0000-000000000000'
    }

    return client.post(ADMIN_ENDPOINTS.UPDATE_FAQ, payload)
  },

  getNotice(noticeId: string) {
    return client.get(ADMIN_ENDPOINTS.PAGED_NOTICES + noticeId)
  },
  getPagedNotices(pageNumber: number, pageSize: number) {
    const query = `?pageNumber=${pageNumber}&pageSize=${pageSize}`
    return client.get(ADMIN_ENDPOINTS.PAGED_NOTICES + query)
  },
  deleteNotice(noticeId: string) {
    return client.delete(`${ADMIN_ENDPOINTS.DELETED_NOTICE}/${noticeId}`)
  },

  postNotice(noticeData: NoticeRequest) {
    const payload = { ...noticeData }
    if (!payload.noticeId) {
      payload.noticeId = '00000000-0000-0000-0000-000000000000'
    }

    return client.post(ADMIN_ENDPOINTS.UPDATE_NOTICE, payload)
  },

  postScraping(swLat: number, swLng: number, neLat: number, neLng: number) {
    const payload = {
      leftBottomLatitude: swLat,
      leftBottomLongitude: swLng,
      rightTopLatitude: neLat,
      rightTopLongitude: neLng,
    }

    return client.post(ADMIN_ENDPOINTS.SEND_SCRAPING, payload)
  },

  getAddress() {
    return client.get(ADMIN_ENDPOINTS.GET_ADDRESS)
  },

  migrateJrs(datePayload: { storeId: string; jrsId: string; isApproved: boolean }) {
    return client.post(ADMIN_ENDPOINTS.MIGRATED_JRS, datePayload)
  },

  batchMigrateJrs(items: Array<{ storeId: string; jrsId: string; isApproved: boolean }>) {
    return client.post(ADMIN_ENDPOINTS.BATCH_MIGRATE_JRS, items)
  },

  getPagedJrsList(
    pageNumber: number,
    pageSize: number,
    storeName: string,
    status?: number | null,
    JRSUserRequestType?: number,
    isMigrated?: boolean | null,
    SearchAddress?: string | '',
  ) {
    let query =
      '?JRSUserRequestType=' +
      JRSUserRequestType +
      '&pageNumber=' +
      pageNumber +
      '&pageSize=' +
      pageSize +
      '&storeName=' +
      storeName

    if (status !== null) {
      query += `&status=${status}`
    }

    if (isMigrated !== null) {
      query += `&isMigrated=${isMigrated}`
    }
    if (SearchAddress !== null) {
      query += `&SearchAddress=${SearchAddress}`
    }

    return client.get(ADMIN_ENDPOINTS.PAGED_JRSLIST + query)
  },
}
